import { BooleanFilterEnum } from '../../../enums/boolean-filter.enum';
import { ApiRequestFilters } from '../../../types/api-request-filters';

/**
 * Countries filters
 */
export class CountriesFilters extends ApiRequestFilters {
	/**
	 * Hidden value
	 */
	hidden?: BooleanFilterEnum;
}
